import React from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment, Autocomplete } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

const OutletSearch = ({ searchQuery, setSearchQuery, allOutletNames }) => {
  return (
    <Autocomplete
      freeSolo
      options={allOutletNames}
      value={searchQuery}
      onChange={(_, newValue) => setSearchQuery(newValue || '')}
      onInputChange={(_, newInputValue) => setSearchQuery(newInputValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search outlets..."
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            mb: 2,
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
            },
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
        />
      )}
      ListboxProps={{
        style: { maxHeight: '200px' },
      }}
      filterOptions={(options, state) => {
        // Only show options that match the current input
        const inputValue = state.inputValue.toLowerCase().trim();
        if (!inputValue) return options.slice(0, 100); // Limit to first 100 if no input

        return options.filter((option) => option.toLowerCase().includes(inputValue)).slice(0, 100); // Limit to first 100 matches
      }}
    />
  );
};

OutletSearch.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  allOutletNames: PropTypes.array.isRequired,
};

export default OutletSearch;
